<template>
    <AppHead title="Submit A Review">
        <meta name="robots" content="noindex, follow"/>
    </AppHead>

    <from-website :website="website">
        <component
            :is="reviewFormComponent"

            :website="website"
            :product="product"
            :externalProduct="externalProduct"
            :questions="product.questions"
            :request-url="requestUrl"
            :tyre-details="tyreDetails"
            :rating="rating"
            :user="user"
            :order-reference="orderReference"
            :fitter-identifier="fitterIdentifier"
            :product-external-identifier="productExternalIdentifier"
            :referral-types="referralTypes"

            :allow-product-edit="false"
        ></component>
    </from-website>
</template>
<script>
import CreateTyreReviewForm from "@/Components/Reviews/Forms/CreateTyreReviewForm.vue";
import CreateProductReviewForm from "@/Components/Reviews/Forms/CreateProductReviewForm.vue";
import FromWebsite from "@/Layouts/FromWebsite.vue";
import AppHead from "@/Components/AppSeoTags";

export default {
    components: {AppHead, CreateTyreReviewForm, CreateProductReviewForm, FromWebsite},
    layout: null,
    props: {
        website: Object,
        product: Object,
        externalProduct: Object,
        user: Object,
        tyreDetails: Object,
        rating: [String, Number],
        orderReference: String,
        fitterIdentifier: String,
        productExternalIdentifier: String,
        referralTypes: Array
    },
    computed: {
        reviewFormComponent() {
            return this.product.type === 'tyre' ? 'CreateTyreReviewForm' : 'CreateProductReviewForm';
        },
        requestUrl() {
            return `/websites/${this.website.name}/products/${this.product.identifier}/reviews`;
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
